import { useCallback } from 'react'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { useActions } from 'common/hooks/useActions'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import { PopupInterface } from 'common/types/entities/popup-interface'
import { toggleActivePopup } from 'publisher/actionsManagement'
import { usePage } from 'publisher/store'
import pageSelectors from 'publisher/store/page/pageSelectors'
import { dispatchPopupOpenedCustomEvent } from 'publisher/utils/popupUtils'

const hasPopupId = (node: HTMLElement | null) =>
  node && node.hasAttribute('popupId')

export const usePopupOpenerRef = () => {
  const togglePopup = useActions(toggleActivePopup)
  const popups = usePage(pageSelectors.getPopupEntities)

  return useCallback(
    (node: HTMLElement | null) => {
      if (node !== null) {
        const openPopup = (node: HTMLElement | null, level = 0) => {
          if (level === 5 || !node) {
            return
          }

          if (hasPopupId(node)) {
            const popup = popups.find(
              popup => popup.id === node.getAttribute('popupId'),
            ) as PopupInterface | OldEntityInterface
            const popupAttrId =
              popup.type === EntityTypeEnum.Popup
                ? popup.htmlAttrId
                : popup?.options?.attrId

            if (popup) {
              togglePopup(popup.id)
              dispatchPopupOpenedCustomEvent(popupAttrId)
            }
          } else {
            level++
            const parent = node.parentNode
            if (parent && parent instanceof HTMLElement) {
              openPopup(parent, level)
            }
          }
        }

        node.addEventListener(
          'click',
          ({ target }) => {
            openPopup(target as HTMLElement | null)
          },
          false,
        )
      }
    },
    [popups, togglePopup],
  )
}
